/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

export enum AddressTypeEnum {
  NOT_SET = 'NotSet',
  INSURED = 'Insured',
  INSURED_LOCATION = 'InsuredLocation',
  INSURER = 'Insurer',
  OCPIP = 'OCPIP',
  PRODUCER = 'Producer',
  NOT_SPECIFIED = 'NotSpecified',
  INVALID = 'Invalid',
  MISSING_ENUM = 'MissingEnum',
}
